// ─────────────────────────────────────────────────────────────
// API CLIENT — calls your Cloudflare Worker
//
// Set this in Cloudflare Pages → Settings → Environment variables:
//   REACT_APP_WORKER_URL = https://meduvita-command-api.YOUR_SUBDOMAIN.workers.dev
//   REACT_APP_DASHBOARD_SECRET = (same value as DASHBOARD_SECRET in your Worker)
// ─────────────────────────────────────────────────────────────

const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';
const SECRET     = process.env.REACT_APP_DASHBOARD_SECRET || '';

export const isConfigured = () => Boolean(WORKER_URL && SECRET);

async function api(path, method = 'GET', body = null) {
  if (!WORKER_URL) throw new Error('WORKER_URL not configured');
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Dashboard-Secret': SECRET,
    },
  };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${WORKER_URL}${path}`, opts);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API error ${res.status}: ${text}`);
  }
  return res.json();
}

// ─── Stats & Pulse ────────────────────────────────────────────
export const getKeyStats   = () => api('/api/stats');
export const getAgentLogs  = () => api('/api/agent-logs');

// ─── Email Queue ──────────────────────────────────────────────
export const getEmailQueue = () => api('/api/email-queue');
export const approveEmail  = (id, platform) => api(`/api/email-queue/${id}/approve`, 'POST', { platform });
export const rejectEmail   = (id, platform) => api(`/api/email-queue/${id}/reject`,  'POST', { platform });

// ─── Escalations ──────────────────────────────────────────────
export const getEscalations     = () => api('/api/escalations');
export const resolveEscalation  = (id, platform) => api(`/api/escalations/${id}/resolve`, 'POST', { platform });

// ─── Ambassadors ──────────────────────────────────────────────
export const getAmbassadors = () => api('/api/ambassadors');
export const addAmbassador  = (data) => api('/api/ambassadors', 'POST', data);

// ─── Studio ───────────────────────────────────────────────────
export const getStudioData      = () => api('/api/studio');
export const updateStudioItem   = (id, data) => api(`/api/studio/${id}`, 'PATCH', data);

// ─── Agent Control ────────────────────────────────────────────
export const triggerAgent = (repo, agent) => api('/api/trigger-agent', 'POST', { repo, agent });

// ─── AI Chat ──────────────────────────────────────────────────
export const chatWithAgent = (messages, agent_context = 'general') =>
  api('/api/chat', 'POST', { messages, agent_context });

// ─── Seed demo data ───────────────────────────────────────────
export const seedDemoData = () => api('/api/seed', 'POST');

// ─── Signup chart data (computed from logs) ───────────────────
export async function getSignupData() {
  const stats = await getKeyStats();
  // Until real user data flows in, return a flat array from stats
  const days = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
  return days.map(d => ({ day: d, meduvita: 0, mmf: 0 }));
}
